import { createNullableProvideInject } from '@collector/shared-ui'

import { AssignIncidentOnPitchConfig } from '../configuration'

export const [
  provideAssignIncidentOnPitchConfig,
  injectAssignIncidentOnPitchConfig,
] = createNullableProvideInject<AssignIncidentOnPitchConfig>(
  'assignIncidentOnPitchConfig',
)
